'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reactRecNReplay;

var _queryString = require('query-string');

var RecordMode = 'rec';
var ReplayMode = 'replay'; // gets all actions stored in localStorage under the given id

var getActions = function getActions(id) {
  var item = window.localStorage.getItem(id);
  return item ? JSON.parse(item) : null;
}; // returns a function that adds the given action to an array
// stored in localStorage under the given id


var storeAction = function storeAction(id) {
  return function (action) {
    var items = getActions(id) || [];
    items.push(action);
    window.localStorage.setItem(id, JSON.stringify(items));
  };
}; // takes a function that accepts an action, and returns a
// function that wrapps said action in an object that
// also includes the time difference from the last time called


var addTiming = function addTiming(recordAction) {
  var lastTime = new Date();
  return function (action) {
    var time = new Date();
    var diff = time - lastTime;
    lastTime = time;
    recordAction({
      diff: diff,
      action: action
    });
  };
}; // takes an array of actions, and returns a function that accepts
// a callback function. This callback will be called with the action as
// param in the same intervall that the actions were stored.


var replayer = function replayer(actions) {
  var iterator = actions[Symbol.iterator]();

  var eachAction = function eachAction(callback) {
    var _iterator$next = iterator.next();

    var done = _iterator$next.done;
    var value = _iterator$next.value;

    if (done) {
      return;
    }

    var action = value.action;
    var diff = value.diff;
    setTimeout(function () {
      callback(action);
      eachAction(callback);
    }, diff);
  };

  return eachAction;
}; // eslint-disable-next-line


var recordMddleware = function recordMddleware(storeAction) {
  return function (store) {
    return function (next) {
      return function (action) {
        storeAction(action);
        return next(action);
      };
    };
  };
};

var replaydMddleware = function replaydMddleware(onActionReplay) {
  return function (store) {
    onActionReplay(function (action) {
      store.dispatch(action);
    });
    return function (next) {
      return function (action) {
        return next(action);
      };
    };
  };
}; // eslint-disable-next-line


var noActionMiddleware = function noActionMiddleware(store) {
  return function (next) {
    return function (action) {
      return next(action);
    };
  };
};

var getQueryStringOptions = function getQueryStringOptions() {
  var _parse = (0, _queryString.parse)(window.location.search);

  var record = _parse.record;
  var replay = _parse.replay;

  if (!!record || record === null) {
    return {
      mode: RecordMode,
      id: record || ''
    };
  }

  if (!!replay || replay === null) {
    return {
      mode: ReplayMode,
      id: replay || ''
    };
  }

  return {
    mode: '',
    id: ''
  };
};

function reactRecNReplay() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? getQueryStringOptions() : arguments[0];
  var mode = options.mode;
  var id = options.id;
  var storageId = 'http://reactRecNReplay/v1/' + id;

  if (mode === RecordMode) {
    return recordMddleware(addTiming(storeAction(storageId)));
  }

  if (mode === ReplayMode) {
    var actions = getActions(storageId);

    if (actions) {
      return replaydMddleware(replayer(actions));
    } // eslint-disable-next-line


    console.warn('No actions with id=' + id + ' found to replay!');
  }

  return noActionMiddleware;
}